import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const arjSettingsLoadingLimitsLegacyRedirectRoute: InvariantJiraRoute = {
	name: 'arj-settings-loading-limits-redirect',
	path: '/secure/PortfolioLoadingLimits.jspa',
};
